import { DateTime } from 'luxon';
import { ISODateString } from '../../types/shared/ISODateString';

export const createDateRangeFromDays = (daysFrom: number, daysTo: number = 0): [ISODateString, ISODateString] => [
  DateTime.local().plus({ days: daysFrom }).toISODate(),
  DateTime.local().plus({ days: daysTo }).toISODate(),
];
